import Empty from "components/Empty";
import styles from "../AddStaff/AddStaff.module.scss";
import ExpandableSearchBar from "accountOwner/pages/AddEvent/SchedulingAssistant/components/ExpandableSearchBar";
import { withTranslation } from "react-i18next";
import "accountOwner/pages/Scheduler/components/SchedulerFilters/SchedulerFilters.scss";

const radioType = "radio";

const getStaffDisplayName = (item) => {
  const user = item?.user ? item?.user : item;
  return `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
};

const ReportsToCheckboxes = ({
  memberList,
  setSelectedVal,
  selectedVal,
  memberListSearch,
  onSearch,
  inputType = radioType,
  t,
  checkMultiple,
  allElement = null,
  modalOpened,
  sidebarFilter = false,
}) => {
  const isRadioType = radioType === inputType;
  const listClassName = sidebarFilter
    ? "filter-list"
    : [
        styles["change-list"],
        styles["mb-40"],
        styles["reports-to-list"],
        styles["change-position-radio"],
        modalOpened ? styles["modal-view-lists"] : "",
      ]
        .filter(Boolean)
        .join(" ");

  return (
    <>
      <div
        className={
          sidebarFilter ? "search-box w-100" : `search-box w-100 ${styles["search-box"]}`
        }
      >
        <ExpandableSearchBar
          placeholder={t("accountOwner.searchByName")}
          searchValue={memberListSearch}
          setSearchValue={onSearch}
          expanded={true}
        />
      </div>

      {memberList && memberList.length > 0 ? (
        <ul className={listClassName}>
          {allElement}
          {memberList.map((item, key, arr) => {
            const staffName = getStaffDisplayName(item);
            const itemKey = item.id || `${item.userId}${item.officeId}`;

            if (sidebarFilter) {
              return (
                <li key={itemKey}>
                  <div className={`ch-${inputType}`}>
                    <label>
                      <input
                        type={inputType}
                        onChange={() => setSelectedVal(item)}
                        checked={
                          isRadioType
                            ? item?.userId === selectedVal?.userId
                            : checkMultiple(item)
                        }
                        name="blockTimeslotAallDoctors"
                      />{" "}
                      <span>{staffName}</span>
                    </label>
                  </div>
                </li>
              );
            }

            return (
              <li
                key={itemKey}
                className={`${arr.length - 1 === key ? "" : "border-bottom"}`}
              >
                <div className={`ch-${inputType}`}>
                  <label className="mr-5">
                    <input
                      type={inputType}
                      readOnly
                      onClick={() => setSelectedVal(item)}
                      checked={
                        isRadioType
                          ? item?.userId === selectedVal?.userId
                          : checkMultiple(item)
                      }
                      name="blockTimeslotAallDoctors"
                    />
                    <span
                      className="d-flex align-items-center"
                      style={{ minHeight: "38px" }}
                    >
                      <div className={`${styles["staff-name-label"]}`}>
                        {staffName}
                      </div>
                    </span>
                  </label>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <Empty Message={t("noStaffMemberFound")} />
      )}
    </>
  );
};
export default withTranslation()(ReportsToCheckboxes);
